module.exports = __webpack_public_path__ + "static/media/GillSansBold.7edc7162.otf";